import type { MetaGamesEventType } from '../../dto/metagames.types';
import type { SportEventType } from '../../dto/sport.types';
import type { CoinType } from '../cointype/CoinTypeStore';

export type GameProviderName = 'PRAGMATIC' | 'RUBY' | 'Barouletta Gaming' | 'Crownslots';

export type MasterCasinoProvider = {
  masterCasinoProviderId: number;
  name: string;
  isActive: boolean;
  thumbnailUrl: string | null;
  jackpotBadgeUrl: string | null;
  masterGameAggregatorId: number | null;
  uuid: string;
  createdAt: string;
  updatedAt: string;
};

type GameLabelStyle = {
  background: string;
  color: string;
};

type GameLabelType = 'manual' | 'tournament' | 'daily_mission' | 'royal_crowns';

export type GameLabel = {
  id: string;
  name: string;
  type: GameLabelType;
  gcStyle?: GameLabelStyle;
  scStyle?: GameLabelStyle;
  iconSrc?: string;
  weight: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export interface GameCategoryConnection {
  gameSubcategoryId: number;
  masterCasinoGameId: number;
  masterGameSubCategoryId: number;
  orderId: number;
}

export interface Game {
  masterCasinoGameId: number;
  name: string;
  masterCasinoProviderId: number;
  identifier: string;
  thumbnailUrl: string | null;
  thumbnailHrUrl: string | null;
  thumbnailShortUrl: string | null;
  thumbnailShortHrUrl: string | null;
  thumbnailLongUrl: string | null;
  thumbnailLongHrUrl: string | null;
  masterGameSubCategoryId: number;
  masterCasinoCategoryId: number;
  masterCasinoCategoryName: string;
  moreDetails?: any;
  MasterCasinoProvider?: MasterCasinoProvider;
  masterCasinoProvider?: MasterCasinoProvider;
  gameLabels: GameLabel[];
  gameCategoryConnections?: GameCategoryConnection[];
}

export interface GamesResponse {
  games: Game[];
  hasMoreGames: boolean;
}

export interface LaunchGameData {
  gameUrl: string;
  slotGameUrl: string;
  isGameUi: boolean;
  gameId: string;
  gameName: string;
  identifier: string;
  providerName: GameProviderName;
  providerId: number;
  sportsEvents?: {
    token: string;
    path: string;
    type: SportEventType;
  };
  metagames?: {
    token: string;
    path: string;
    type: MetaGamesEventType;
  };
}

export type LaunchGameRequest = {
  gameId: string | number;
  type?: string;
  coin: CoinType;
};

export type LaunchGameResponse = {
  error: number;
  description: string;
  gameUrl: string;
  success: boolean;
};

export enum GameProvider {
  Pragmatic = 'Pragmatic Play',
  Playson = 'Playson',
  PlaysonInfin = 'Playson  infin',
  Crownslots = 'Crownslots',
}
